import { Link } from 'react-router'

import logo from '../../assets/logo.svg'
import { Container } from '../../components/Container'
import { LoginButtons } from '../../components/Login'

export function PrivateNavigation() {
  return (
    <Container>
      <div className="flex items-center justify-between py-4">
        <Link to="/insure/insurance">
          <img src={logo} alt="Logo" width={108} />{' '}
        </Link>

        <LoginButtons />
      </div>
    </Container>
  )
}
